import { observer } from 'mobx-react';
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { store } from 'Models/Store';
import { checkUserDetailsAndShowPopup } from 'Views/Pages/Login/LoginUtils';

// Set by ResetPasswordPage before its full-reload redirect, since that path bypasses
// the onLoginSuccess handlers that would normally run the missing-details popup.
export const PENDING_PROFILE_CHECK_FLAG = 'pendingProfilePromptCheck';

export const PostLoginProfileCheck = observer(() => {
	const navigate = useNavigate();
	const handledRef = useRef(false);

	useEffect(() => {
		if (handledRef.current) return;
		if (!store.loggedIn) return;
		if (sessionStorage.getItem(PENDING_PROFILE_CHECK_FLAG) !== '1') return;

		handledRef.current = true;
		sessionStorage.removeItem(PENDING_PROFILE_CHECK_FLAG);
		checkUserDetailsAndShowPopup(navigate);
	}, [store.loggedIn, navigate]);

	return null;
});
